import { Link } from "react-router-dom";

export function RosterHomePage() {
  return (
    <div className="card">
      <h2>Roster</h2>
      <p className="muted">
        View students, parents, teachers, families, and the relationship tables that drive messaging permissions.
      </p>

      <div style={{ display: "grid", gap: 12, marginTop: 12 }}>
        <Link className="btn secondary" to="/roster/students">
          Students
        </Link>
        <Link className="btn secondary" to="/roster/parents">
          Parents
        </Link>
        <Link className="btn secondary" to="/roster/teachers">
          Teachers / Staff
        </Link>
        <Link className="btn secondary" to="/roster/links">
          Parent / Student Links
        </Link>
        <Link className="btn secondary" to="/families">
          Families
        </Link>
        <Link className="btn" to="/roster/import">
          Roster Import (CSV)
        </Link>
      </div>
    </div>
  );
}